/**
 * Presentación UI del módulo financiero (FINANZAS-CORE-04).
 * No contiene lógica de cálculo — solo textos, colores y etiquetas.
 */

export const HELP_GANANCIAS_MES = `Ganancia Bruta = Ventas − costo de mercadería.
No incluye alquileres, impuestos, sueldos ni otros gastos.`;

export const HELP_COBERTURA = `Real: ventas con costo histórico guardado.

Estimada: ventas calculadas con el costo actual del producto.

No calculable: ventas sin información suficiente.`;

export const HELP_CALIDAD = `Mide la confiabilidad y completitud de los datos financieros (no la rentabilidad ni la “salud económica” del negocio).
A mayor cobertura real y productos con costo configurado, mayor precisión.
Sin ventas en el período, la calidad de datos no se puede evaluar.`;

export const COBERTURA_EXPLICACIONES = {
  real: 'Ventas con costo histórico guardado al momento de la venta (snapshot).',
  estimada: 'Ventas calculadas usando el costo actual del producto en catálogo.',
  no_calculable: 'Ventas sin información suficiente para determinar el costo.'
};

export const GANANCIAS_SUBTITULO = 'Calculada según costos registrados';

/**
 * Etiqueta de calidad solo para UI.
 * score null / evaluable=false → estado neutral (no "Excelente").
 */
export function getCalidadDisplay(score, options = {}) {
  const evaluable = options.evaluable;
  if (evaluable === false || score == null || score === '') {
    return {
      label: 'Datos insuficientes',
      badgeClass: 'bg-slate-500/20 text-slate-300 border-slate-500/40',
      tone: 'neutral',
      evaluable: false
    };
  }
  const s = Number(score);
  if (!Number.isFinite(s)) {
    return {
      label: 'Datos insuficientes',
      badgeClass: 'bg-slate-500/20 text-slate-300 border-slate-500/40',
      tone: 'neutral',
      evaluable: false
    };
  }
  if (s >= 95) {
    return { label: 'Excelente', badgeClass: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/40', tone: 'positive', evaluable: true };
  }
  if (s >= 80) {
    return { label: 'Muy buena', badgeClass: 'bg-sky-500/20 text-sky-300 border-sky-500/40', tone: 'positive', evaluable: true };
  }
  if (s >= 60) {
    return { label: 'Buena', badgeClass: 'bg-amber-500/20 text-amber-300 border-amber-500/40', tone: 'warn', evaluable: true };
  }
  return { label: 'Requiere revisión', badgeClass: 'bg-red-500/20 text-red-300 border-red-500/40', tone: 'negative', evaluable: true };
}

export const COBERTURA_ROW_STYLES = {
  real: 'text-emerald-300',
  estimada: 'text-amber-300',
  no_calculable: 'text-red-300'
};

/** Resuelve timestamp de stats materializados (si el API lo expone). */
export function resolveFinanzasTimestamp(...sources) {
  for (const source of sources) {
    if (!source) continue;
    if (typeof source === 'string' && source.trim()) return source.trim();
    if (source instanceof Date && !Number.isNaN(source.getTime())) return source.toISOString();
    if (typeof source === 'object') {
      const nested = source.computedAt || source.ventasComputedAt || source.catalogComputedAt
        || source.actualizadoEn || source.updatedAt || source.builtAt;
      if (nested) {
        const resolved = resolveFinanzasTimestamp(nested);
        if (resolved) return resolved;
      }
    }
  }
  return null;
}

/** Formato legible para sello de confianza (es-AR). */
export function formatFinanzasActualizado(isoOrDate) {
  const raw = resolveFinanzasTimestamp(isoOrDate);
  if (!raw) return null;
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return null;
  try {
    return date.toLocaleString('es-AR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return null;
  }
}
